export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="23" fill="#3E5C49" />
    <path d="M14 30c0-7 5-12 11-12s9 4 9 8-3 7-8 7h-5l-5 4v-5c-1-.6-2-1.2-2-2z" fill="#F6F1E9" />
    <path d="M25 30c0-5 2-8 6-10-1 4-3 7-6 10z" fill="#E9A895" />
    <path d="M25 30c-1-4-3-6-6-7 1 3 3 5 6 7z" fill="#B9CFA9" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display text-lg text-ink">Ana Falaschi</span>
      <span className="block text-[11px] uppercase tracking-[0.22em] text-sage mt-1">Psicologia on-line</span>
    </span>
  </span>
);
